<app-header></app-header>

<div class="tarification-page">
  <!-- Section Tarification -->
  <section class="pricing-section py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h1 class="pricing-title mb-4">Tarification</h1>
          <p class="pricing-subtitle mb-5">
            Accédez à votre document converti en quelques instants. <br>
            Sélectionnez l'option qui vous convient le mieux. Aucun engagement. Résiliation facile.
          </p>
        </div>
      </div>

      <!-- Pricing Cards -->
      <div class="row justify-content-center">
        <!-- Accès 24H -->
        <div class="col-md-4 mb-4">
          <div class="pricing-card h-100">
            <div class="pricing-header access-24h">
              <h3 class="text-white mb-0">ACCÈS 24H</h3>
            </div>
            <div class="pricing-body p-4">
              <div class="price-circle access-24h-circle mb-4">
                <span class="price-amount">0,50€</span>
              </div>
              <h4 class="pricing-subtitle mb-3">Idéal pour un besoin rapide</h4>
              <ul class="pricing-features list-unstyled">
                <li class="mb-2">Téléchargement immédiat du fichier converti</li>
                <li class="mb-2">Accès pendant 24 heures</li>
                <li class="mb-2">Aucune limite de téléchargement</li>
                <li class="mb-2">Assistance par email</li>
              </ul>
              <button class="btn btn-primary w-100 access-24h-btn">CHOISIR CETTE OFFRE</button>
            </div>
          </div>
            <!-- Disclaimer -->
            <div class="row justify-content-center mt-4">
                <div class="text-start">
                    <p class="disclaimer-text">
                    *Renouvellement automatique : 19,80 € tous les 14 jours (annulable à tout moment)
                    </p>
                </div>
            </div>
        </div>

        <!-- Accès 14 Jours -->
        <div class="col-md-4 mb-4">
          <div class="pricing-card h-100">
            <div class="pricing-header access-14days">
              <h3 class="text-white mb-0">ACCÈS 14 JOURS</h3>
            </div>
            <div class="pricing-body p-4">
              <div class="price-circle access-14days-circle mb-4">
                <span class="price-amount">19,80 €</span>
              </div>
              <h4 class="pricing-subtitle mb-3">Parfait pour un usage régulier</h4>
              <ul class="pricing-features list-unstyled">
                <li class="mb-2">Accès complet à tous les fichiers convertis</li>
                <li class="mb-2">Téléchargements illimités pendant 14 jours</li>
                <li class="mb-2">Historique de vos conversions</li>
                <li class="mb-2">Support prioritaire</li>
                <li class="mb-2">Résiliation en un clic, sans engagement</li>
              </ul>
              <button class="btn btn-primary w-100 access-14days-btn">CHOISIR CETTE OFFRE</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section Inclus dans chaque formule -->
  <section class="features-section py-5 bg-light mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h2 class="section-title mb-5">Inclus dans chaque formule</h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-md-6">
              <ul class="features-list">
                <li class="mb-3">Conversion rapide de PDF vers Word</li>
                <li class="mb-3">Interface en ligne, sans installation</li>
                <li class="mb-3">Compatible mobile, tablette et ordinateur</li>
                <li class="mb-3">Connexion sécurisée</li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="features-list">
                <li class="mb-3">Téléchargements illimités</li>
                <li class="mb-3">Accès immédiat après paiement</li>
                <li class="mb-3">Assistance par email</li>
                <li class="mb-3">Disponible 24h/24, 7j/7</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Section FAQ -->
  <section class="faq-section py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h2 class="section-title mb-5">Section FAQ</h2>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="faq-item mb-4">
            <h4 class="faq-question mb-2">Puis-je annuler mon abonnement?</h4>
            <p class="faq-answer">Oui, vous pouvez annuler à tout moment via votre espace utilisateur. Aucun frais caché.</p>
          </div>
          <div class="faq-item mb-4">
            <h4 class="faq-question mb-2">Quand recevrai-je mon fichier?</h4>
            <p class="faq-answer">Dès que la conversion est terminée, vous recevez un lien de téléchargement par email.</p>
          </div>
          <div class="faq-item mb-4">
            <h4 class="faq-question mb-2">Mon fichier est-il sécurisé?</h4>
            <p class="faq-answer">Oui, vos documents sont protégés et conservés de manière confidentielle.</p>
          </div>
          <div class="faq-item mb-4">
            <h4 class="faq-question mb-2">Puis-je utiliser le service depuis mon téléphone?</h4>
            <p class="faq-answer">Oui, notre outil est entièrement compatible avec les smartphones et les tablettes. Vous pouvez convertir vos fichiers depuis n'importe quel appareil.</p>
          </div>
          <div class="faq-item mb-4">
            <h4 class="faq-question mb-2">Que se passe-t-il après les 24h ou 14 jours?</h4>
            <p class="faq-answer">Si vous ne résiliez pas, votre accès est automatiquement renouvelé selon l'offre choisie. Vous pouvez annuler à tout moment depuis votre espace client.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- Séparateur entre le contenu principal et le footer -->
<div class="content-separator"></div>

<app-footer></app-footer>